export {
  getLibraryList,
  saveLibraryData,
  deleteLibraryById,
  getLibraryDetail,
  calculateImpedance,
  createLibrary,
  getFileContent,
  getTouchstoneParse,
  getPkgSpiceModelList,
  getFolderDetail,
  getIbisModelParse,
  getTouchstoneParsePorts,
  getLibraryFolderChildren
} from './libraryCtrl';

export {
  getLibraryArray,
  libraryItem
} from './libraryTree';

export {
  libraryTypeList
} from './libraryConstructor';

export {
  getIBISModelList,
  getIbisAmiFileList,
  getCPHYIBISModelList,
  deleteFolderChild
} from './libraryHelper';

export const LIBRARY_INDEX = 0;
// Primary index
export const TRACE_INDEX = 0,
  VIA_INDEX = 1,
  PASSIVE_INDEX = 2,
  BUFFER_INDEX = 3,
  EXTRACTION_OPTIONS_INDEX = 4,
  ADS_OPTIONS_INDEX = 5,
  EYE_MASK_INDEX = 6,
  CHANNEL_MODEL_INDEX = 7,
  GENERIC_INDEX = 8,
  LEQ_RESPONSE_INDEX = 9,
  USER_DEFINED_NETLIST_INDEX = 10,
  REFERENCE_LINES_INDEX = 11;
//  secondary index
// - passive
export const PASSIVE_TOUCHSTONE_INDEX = 0,
  PASSIVE_SPICE_INDEX = 1;
// - buffer
export const IBIS_AMI_INDEX = 0,
  IBIS_INDEX = 1,
  BUFFER_SPICE_INDEX = 2;
// - extraction options
export const HFSS_OPTIONS_INDEX = 0,
  SIWAVE_OPTIONS_INDEX = 1;
// - generic
export const GENERIC_TOUCHSTONE_INDEX = 0,
  GENERIC_SPICE_INDEX = 1;
// - channel model
export const PKG_INDEX = 0,
  PCB_INDEX = 1,
  CONNECTOR_INDEX = 2,
  CABLE_INDEX = 3;